import React, { useState } from "react";
import { supabase } from "../supabaseclient";
import { useNavigate } from "react-router-dom";
import AuthButton from "../components/authbutton";

function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      });

      if (error) {
        setError(error.message);
        setLoading(false);
        return;
      }

      if (data?.user) {
        try {
          // Add timeout to prevent hanging
          const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => reject(new Error("Profile check timeout")), 5000);
          });

          // Check if user has complete profile with timeout
          const profilePromise = supabase
            .from("users")
            .select("profile_created")
            .eq("id", data.user.id)
            .single();

          const { data: profile, error: profileError } = await Promise.race([
            profilePromise,
            timeoutPromise,
          ]);

          if (profileError) {
            // If there's an error checking profile, redirect to complete profile
            navigate("/complete-profile");
          } else if (!profile?.profile_created) {
            navigate("/complete-profile");
          } else {
            navigate("/jobs");
          }
        } catch (profileError) {
          console.error("Error checking profile:", profileError);
          // If there's an error, redirect to complete profile
          navigate("/complete-profile");
        }
      }
    } catch (error) {
      console.error("Sign in error:", error);
      setError("An unexpected error occurred");
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "50px auto", padding: "2rem" }}>
      <h1>Sign In</h1>

      {/* Email/Password Form */}
      <div style={{ marginBottom: "2rem" }}>
        <h2>Sign in with Email</h2>
        <form onSubmit={handleEmailSignIn}>
          <div style={{ marginBottom: "1rem" }}>
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "0.5rem",
                marginTop: "0.25rem",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "0.5rem",
                marginTop: "0.25rem",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          {error && (
            <div
              style={{
                color: "red",
                marginBottom: "1rem",
                padding: "0.5rem",
                backgroundColor: "#ffe6e6",
                borderRadius: "4px",
              }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "0.75rem",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>

      {/* Divider */}
      <div
        style={{
          textAlign: "center",
          margin: "2rem 0",
          position: "relative",
        }}
      >
        <span
          style={{
            backgroundColor: "white",
            padding: "0 1rem",
            color: "#666",
          }}
        >
          OR
        </span>
        <hr
          style={{
            position: "absolute",
            top: "50%",
            left: 0,
            right: 0,
            zIndex: -1,
          }}
        />
      </div>

      {/* OAuth Buttons */}
      <div>
        <h2>Sign in with Social</h2>
        <AuthButton />
      </div>

      {/* Sign Up Link */}
      <div
        style={{
          textAlign: "center",
          marginTop: "2rem",
          paddingTop: "1rem",
          borderTop: "1px solid #eee",
        }}
      >
        <p>Don't have an account?</p>
        <button
          onClick={() => navigate("/sign-up")}
          style={{
            background: "none",
            border: "none",
            color: "#007bff",
            textDecoration: "underline",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          Sign up here
        </button>
      </div>
    </div>
  );
}

export default SignIn;
